import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useWeatherBlock = () => {
    const dispatch = useDispatch();

    const { weather, can_show_financial_info, is_customer } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );

    const onAddWeather = useCallback(() => {
        dispatch(dashboardActions.onModalMode('editInformation'));
    }, []);

    const onShowModal = useCallback(() => {
        dispatch(dashboardActions.onModalMode('weatherModal'));
    }, []);
    return { onShowModal, weather, onAddWeather, can_show_financial_info, is_customer };
};
